import { PropsWithChildren, use } from 'react';

import { Box } from '../../../box/components/Box/Box';
import { IconButton } from '../../../button/components/IconButton/IconButton';
import { Divider } from '../../../divider/components/Divider/Divider';
import { Typography } from '../../../typography/components/Typography/Typography';

import { FlyoutContext } from './context';

const iconMap = {
   left: 'chevron-left',
   right: 'chevron-right',
   bottom: 'chevron-down'
};

interface Props extends PropsWithChildren {
   closeLabel?: string;
   closeIcon?: string;
   onCloseClick?: () => void;
}

export const FlyoutHeader = ({ closeLabel = 'close', closeIcon, onCloseClick, children }: Props) => {
   const { titleId, position, onClose } = use(FlyoutContext);

   const handleClose = () => {
      if (onCloseClick) {
         onCloseClick();
         return;
      }

      onClose?.();
   };

   return (
      <Box gap="md" spacing={{ x: 'md', y: 'lg' }} direction="column">
         <Box items="center" direction={position === 'left' ? 'row-reverse' : 'row'} justify={position === 'left' ? 'end' : 'between'}>
            <Typography id={titleId} component="h4" variant="heading-4" color="strong">
               {children}
            </Typography>
            <IconButton icon={closeIcon ?? iconMap[position]} variant="inherit" ariaLabel={closeLabel} onClick={handleClose} />
         </Box>
         <Divider />
      </Box>
   );
};
